import { createFileRoute } from '@tanstack/react-router';

import { CreateParkAndRideFacility } from '@/components/management/layout/CreateParkAndRideFacility';
import { backendApiStationsFindOneOptions } from '@/modules/api/backend/@tanstack/react-query.gen';

export const Route = createFileRoute('/_authenticated/management/stations/$stationId/park-and-ride-facilities/create')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
  beforeLoad: async ({ params: { stationId }, context: { queryClient } }) => {
    const stationData = await queryClient.ensureQueryData(
      backendApiStationsFindOneOptions({
        path: { stationId },
      }),
    );

    return {
      breadcrumb: 'Neue P+R Anlage',
      stationData,
    };
  },
});

function RouteComponent() {
  const { stationId } = Route.useParams();
  const { stationData } = Route.useMatch().context;

  return <CreateParkAndRideFacility stationData={stationData} stationId={stationId} />;
}
